import { __rest } from "tslib";
import axios from 'axios';
import getApiUrl from '../common/getApiUrl';
import trimValues from '../common/trimValues';
import { IS_CLIENT } from '../constants';
/** Request Header to whitelist requests for tst and int endpoints from Azure while doing next SSG and ISR */
export const getWhitelistingHeader = () => process.env.NODE_ENVIRONMENT !== 'production'
    ? {
        [`${process.env.HEADER_ACCESS_TOKEN_KEY_NON_PROD}`]: process.env.HEADER_ACCESS_TOKEN_VALUE_NON_PROD,
    }
    : {};
/** Request Header to whitelist requests from Azure while doing next SSG and ISR to prevent WAF request rate limiting */
export const getWAFWhitelistingHeader = () => !IS_CLIENT
    ? {
        [`${process.env.HEADER_ACCESS_TOKEN_KEY_DDOS}`]: process.env.HEADER_ACCESS_TOKEN_VALUE_DDOS,
        'User-Agent': process.env.USER_AGENT_DDOSWHITELIST,
    }
    : {};
/** Request Header for SSR pages during Maintenance Release */
export const getMaintenanceHeader = () => {
    return { 'goep-bps': 'on' };
};
export const getCookieHeader = (cookie) => (cookie ? { Cookie: cookie } : {});
export const createRequestModule = () => {
    const axiosInstance = axios.create();
    const makeRequest = ({ method }) => (endpoint, _a = {}) => {
        var { data = {}, headers = {}, params = {}, timeout = 0, shouldTrimData = method !== 'get', shouldRemoveData = false, gzip = false } = _a, options = __rest(_a, ["data", "headers", "params", "timeout", "shouldTrimData", "shouldRemoveData", "gzip"]);
        return axiosInstance(Object.assign(Object.assign({ method, url: getApiUrl(endpoint, options) }, (!shouldRemoveData ? { data: shouldTrimData ? trimValues(data) : data } : {})), { headers: Object.assign(Object.assign({ Accept: 'application/json', 'Content-Type': 'application/json' }, (gzip && {
                'Accept-Encoding': 'gzip',
            })), headers), params,
            timeout }));
    };
    return {
        get: makeRequest({ method: 'get' }),
        patch: makeRequest({ method: 'patch' }),
        post: makeRequest({ method: 'post' }),
        delete: makeRequest({ method: 'delete' }),
        put: makeRequest({ method: 'put' }),
        axiosInstance,
    };
};
export default createRequestModule();
//# sourceMappingURL=request.js.map